import Swal from 'sweetalert2';

const swal = Swal.mixin({
  customClass: {
    confirmButton: 'bg-primary text-white rounded-lg py-3 px-5 mx-1',
    cancelButton: 'bg-active text-black rounded-lg py-3 px-5 mx-1',
  },
  buttonsStyling: false,
});

const swalSuccessCustom = Swal.mixin({
  customClass: {
    confirmButton: 'bg-[#2A61CF] text-white rounded-md py-2 px-4 mx-1',
    cancelButton: 'bg-white border border-[#D5D7DA] text-[#787878] rounded-md py-2 px-4 mx-1',
    title: 'text-2xl text-black font-semibold',
    closeButton: 'text-black text-2xl hover:text-red-500',
  },
  buttonsStyling: false,
});

const swalSuccessCustom2 = Swal.mixin({
  customClass: {
    confirmButton: 'bg-[#2A61CF] text-white rounded-md py-2 px-4 mx-1',
    cancelButton: 'bg-white border border-[#D5D7DA] text-[#787878] rounded-md py-2 px-4 mx-1',
    title: 'text-2xl text-black font-medium',
    closeButton: 'text-black text-2xl hover:text-red-500',
  },
  buttonsStyling: false,
});

const swalSuccessCustom3 = Swal.mixin({
  customClass: {
    confirmButton: 'bg-[#155EEF] text-white rounded-md py-2 px-4 mx-1',
    cancelButton: 'bg-white border border-[#D5D7DA] text-[#787878] rounded-md py-2 px-4 mx-1',
    title: 'text-2xl text-black font-semibold',
    closeButton: 'text-black text-2xl hover:text-red-500',
  },
  buttonsStyling: false,
});

const swalSuccessDefault = swalSuccessCustom.mixin({
  title: 'Success',
  text: ' success',
  confirmButtonText: 'Go to request',
  cancelButtonText: 'Create new',
  imageUrl: '/alert/success.png',
  showCloseButton: true,
  showCancelButton: true,
  reverseButtons: true,
});

const swalSuccessDefault2 = swalSuccessCustom.mixin({
  title: 'Task has been completed',
  text: ' success',
  confirmButtonText: 'Tutup',
  imageUrl: '/alert/success.png',
  showCloseButton: true,
});

const swalSuccessDefault3 = swalSuccessCustom3.mixin({
  title: 'Success',
  text: ' success',
  confirmButtonText: `
    <span class="flex items-center justify-center gap-2">
      Go to My Task 
      <svg xmlns="http://www.w3.org/2000/svg" class="lucide lucide-arrow-right" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"></path>
        <path d="M12 5l7 7-7 7"></path>
      </svg>
    </span>
  `,
  imageUrl: '/alert/success.png',
  showCloseButton: true,
  showCancelButton: true,
  reverseButtons: true,
});

const swalQuestionDefault = swalSuccessCustom2.mixin({
  title: 'Question',
  text: 'Are you sure?',
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  imageUrl: '/alert/question.png',
  showCloseButton: true,
  showCancelButton: true,
  reverseButtons: true,
});

export { swalSuccessDefault, swalQuestionDefault, swalSuccessDefault2, swalSuccessDefault3 };
